import React, { memo, useCallback } from "react";
import { useSlate } from "slate-react";

import { StyledSelect } from "../../StyledSelect/StyledSelect";
import { Helpers } from "../helpers";
import type { ICustomElement } from "../slateTypes";
import { NodeTypes } from "../slateTypes";

interface IOption {
  value: string;
  label: string;
  depth?: number;
  slateProp?: string;
}

const options: IOption[] = [
  { value: "0", label: "Normal text", slateProp: NodeTypes.PARAGRAPH },
  { value: "1", label: "Heading 1", depth: 1, slateProp: NodeTypes.HEADING },
  { value: "2", label: "Heading 2", depth: 2, slateProp: NodeTypes.HEADING },
  { value: "3", label: "Heading 3", depth: 3, slateProp: NodeTypes.HEADING },
  { value: "4", label: "Heading 4", depth: 4, slateProp: NodeTypes.HEADING },
  { value: "5", label: "Heading 5", depth: 5, slateProp: NodeTypes.HEADING },
  { value: "6", label: "Heading 6", depth: 6, slateProp: NodeTypes.HEADING },
];

const SelectBlockMode: React.FC = memo(() => {
  const editor = useSlate();
  const activeBlock = Helpers.getActiveBlock(editor);

  const handleChange = useCallback((data: any) => {
    Helpers.toggleBlock(editor, data.slateProp, data.depth);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getActiveValue = () => {
    if (activeBlock) {
      const element = activeBlock[0] as ICustomElement;
      if (element.type === NodeTypes.PARAGRAPH) {
        return options[0];
      }
      if (element.type === NodeTypes.HEADING) {
        return options.find(option => option.depth === element.depth);
      }
    }
    return options[0];
  };

  return (
    <StyledSelect
      options={options}
      isSearchable={false}
      isClearable={false}
      isBootstrap={false}
      placeholder="Normal text"
      onChange={handleChange}
      value={getActiveValue()}
      isDisabled={
        activeBlock &&
        (activeBlock[0] as ICustomElement).type === NodeTypes.BLOCK_CODE
      }
    />
  );
});

export { SelectBlockMode };
